import React, { useState } from 'react';
import { requestPasswordReset } from './AuthComponent';

const inputStyle = {
  width: '100%', boxSizing: 'border-box',
  padding: '8px 12px', border: '1px solid #c9cccf', borderRadius: 8,
  fontSize: 14, color: '#202223', outline: 'none',
};

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await requestPasswordReset(email);
      setSent(true);
    } catch (e) {
      setError(e.message || String(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', backgroundColor: '#f6f6f7',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    }}>
      <div style={{
        width: '100%', maxWidth: 380, backgroundColor: '#ffffff', borderRadius: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.06)',
        padding: '28px 28px 24px', margin: '0 16px',
      }}>
        <h1 style={{ fontSize: 18, fontWeight: 700, color: '#202223', margin: '0 0 4px' }}>Reset your password</h1>
        {sent ? (
          <p style={{ color: '#202223', fontSize: 14, marginTop: 16 }}>
            If that email has an account, a reset link is on its way — check your inbox.
          </p>
        ) : (
          <>
            <p style={{ color: '#6d7175', fontSize: 13.5, margin: '0 0 20px' }}>
              Enter your account email and we'll send a reset link.
            </p>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 550 }}>Email</label>
                <input type="email" required autoComplete="email" value={email}
                       onChange={(e) => setEmail(e.target.value)} disabled={loading} style={inputStyle} />
              </div>
              {error && (
                <div style={{ marginBottom: 16, padding: '10px 12px', backgroundColor: '#fff4f4', border: '1px solid #ffd2d2', borderRadius: 8, color: '#d72c0d', fontSize: 13 }}>
                  {error}
                </div>
              )}
              <button type="submit" disabled={loading} style={{
                width: '100%', padding: '9px 16px', backgroundColor: loading ? '#95c9b4' : '#008060',
                color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600,
                cursor: loading ? 'not-allowed' : 'pointer',
              }}>
                {loading ? 'Sending...' : 'Send reset link'}
              </button>
            </form>
          </>
        )}
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <a href="/login" style={{ color: '#6d7175', fontSize: 13 }}>Back to sign in</a>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
